import { FC } from "react";
import { IconPropsType } from ".";

export const Eye: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.14846 8.32908C2.05616 8.20693 1.97535 8.0962 1.90679 8C1.97535 7.9038 2.05616 7.79307 2.14846 7.67092C2.48731 7.22251 2.97613 6.62681 3.57704 6.03385C4.80992 4.81727 6.37533 3.75 8 3.75C9.62467 3.75 11.1901 4.81727 12.423 6.03385C13.0239 6.62681 13.5127 7.22251 13.8515 7.67092C13.9438 7.79307 14.0247 7.90381 14.0932 8C14.0247 8.0962 13.9438 8.20693 13.8515 8.32908C13.5127 8.77749 13.0239 9.37319 12.423 9.96615C11.1901 11.1827 9.62467 12.25 8 12.25C6.37533 12.25 4.80992 11.1827 3.57704 9.96615C2.97613 9.37319 2.48731 8.77749 2.14846 8.32908ZM14.3648 7.60122C14.3649 7.60114 14.3649 7.60113 14.3648 7.6012L14.3648 7.60122ZM14.3648 8.3988C14.3649 8.39887 14.3649 8.39886 14.3648 8.39878L14.3648 8.3988Z"
        stroke={props.color}
        strokeWidth="1.5"
      />
      <circle cx="8" cy="8" r="2.25" stroke={props.color} strokeWidth="1.5" />
    </svg>
  );
};
